import { render, staticRenderFns } from "./OrderPromotion.vue?vue&type=template&id=05302e5d&scoped=true&"
import script from "./OrderPromotion.vue?vue&type=script&lang=js&"
export * from "./OrderPromotion.vue?vue&type=script&lang=js&"
import style0 from "./OrderPromotion.vue?vue&type=style&index=0&id=05302e5d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05302e5d",
  null
  
)

export default component.exports